import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate, currencyFormat } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import { useNavigate } from 'react-router-dom';
import useAxios from 'hooks/useAxios';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import DragDrop from 'components/DragDrop';
import { ModuleAccess } from 'utils/moduleaccess';
import { onExport } from 'utils/helper';
import useContextService from 'hooks/useContextService';



let modulename = "PODetails";
let autoselectlist1 = [];
let widthList = ['Covered Entity', 'Pharmacy Name', 'Reason', 'Drug Name','Member ID']
let currencylist = ['Ordered Pkg. Price','Total Ordered Price','Total Ack. Package Price','Ack. Package Price', 'Billed Package Price','Billed Package Price','Total Billed Price','Total Ack.Price'];
let dateList = ['Billed Date','PO Date','Ack Date'];
let numberlist = ['PO Number','NDC','Invoice #']
let hideColFilterlist = ['PO Number','NDC','Invoice #']
let isRole = ["GWPHA", "GWPHU"]
let tableDataBackup = [];
const ReportPODetailsTable = (props) => {
  const {
    data,
    totalSize,
    loading,
    onPageChange,
    filters,
    onSearchColumnFilters = () => '',
    AllExport,
    slelectedExportPOcoloumms,
    thirdPartyAdmin,
    enableAdd,
    tenantID,
    pageFilters,
    refetch,
    toggleSider,
    collapseSider,
  } = props;
  const API = useAxios();
  tableDataBackup = data;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(tableDataBackup);
  const [isOpen, setIsOpen] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [disableSelectedColumn, setDisableSelectedColumn] = useState(false);
  const [reset, setReset] = useState(false);
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};

  const [coloumselect, setColoumselect] = useState(false);
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });

  const { roles } = profile || {};
  console.log(roles, "roles")
  var con = isRole.includes(roles);
  console.log(con, "con")

  const {
    states: { PODetails },
    setStates,
    resetStates,
  } = useContextService();

  const { search, searchTerms } =
    PODetails;
  const { ceIds, pharmacyids } =
    searchTerms;



  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };
  useEffect(() => {
    setHasExportPermission(ModuleAccess("REP", "EXP"));
  }, []);

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));



  useEffect(() => {


    handlAutocoloms();

  }, []);

  // useEffect(() => {
  //   setState({ tableData: data, backUpData: data });
  // }, [data]);
  const handlAutocoloms = async () => {
    autoselectlist1 = [];
    try {
      const { data } = await API.get(`GWConfig/coveredentity/autoselectcoloumslist/${modulename}`, {
        hasDefaultURL: true,
      });
      if (data) {
        if(data.length>0){
          setDisableSelectedColumn(false);
        }else{
          setDisableSelectedColumn(true);
        }
        for (var x in data) {
          autoselectlist1.push({ "text": data[x].displayName, "dataField": data[x].fieldName });

        }
      }

    } catch (err) {

    }
  }
  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  }
  const { filters: colFilter, backUpData } = state;

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };

  const handleFilterCancel = () => {
    refetch(true);
  };
  const cellRenderLink = (rowData) => {
    return (
      <span
        //className='text-decoration-underline d-inline-block cursor-pointer'
      //onClick={() => handlePODetails(rowData)}
      >
        {rowData.poid}
      </span>
    );
  };
  const cellOptionLink = (rowData) => {
    if (rowData.poStatusID == 5070) {
      return (
        <Button color='link' onClick={() => handleClaimsPO(rowData)}>
          <HoverImage src={ViewClaimsHover} hoverSrc={ViewClaimsHover} alt />
        </Button>
      );
    }
  };
  let maincol1 = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },

    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[0]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[0]?.text) ? 288 : 144,
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[1]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[1]?.text) ? 288 : 144,
      show: autoselectlist1.length > [1] ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[2]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [2] ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[2]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[3]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      sort: hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      show: autoselectlist1.length > [3] ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      action: true,
      width: widthList.includes(autoselectlist1[3]?.text) ? 288 : 144,
      edit: false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[4]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[4]?.text) ? 288 : 144,
      show: autoselectlist1.length > [4] ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[5]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [5] ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[5]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[6]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [6] ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[6]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[7]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [7] ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[7]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[8]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [8] ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[8]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[9]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[9]?.text) ? 288 : 144,
      show: autoselectlist1.length > [9] ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[10]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[10]?.text) ? 288 : 144,
      show: autoselectlist1.length > [10] ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[11]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [11] ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[11]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[12]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [12] ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[12]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,

    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[13]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [13] ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[13]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[14]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [14] ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[14]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[15]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [15] ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[15]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[16]?.dataField,
      text: autoselectlist1[16]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[16]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[16]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[16]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [16] ? true : false,
      inputType: dateList.includes(autoselectlist1[16]?.text) ? "date" : numberlist.includes(autoselectlist1[16]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[16]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[17]?.dataField,
      text: autoselectlist1[17]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[17]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[17]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[17]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [17] ? true : false,
      inputType: dateList.includes(autoselectlist1[17]?.text) ? "date" : numberlist.includes(autoselectlist1[17]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[17]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[18]?.dataField,
      text: autoselectlist1[18]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[18]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[18]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[18]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [18] ? true : false,
      inputType: dateList.includes(autoselectlist1[18]?.text) ? "date" : numberlist.includes(autoselectlist1[18]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[18]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[19]?.dataField,
      text: autoselectlist1[19]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[19]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[19]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[19]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [19] ? true : false,
      inputType: dateList.includes(autoselectlist1[19]?.text) ? "date" : numberlist.includes(autoselectlist1[19]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[19]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[20]?.dataField,
      text: autoselectlist1[20]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[20]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[20]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[20]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [20] ? true : false,
      inputType: dateList.includes(autoselectlist1[20]?.text) ? "date" : numberlist.includes(autoselectlist1[20]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[20]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[21]?.dataField,
      text: autoselectlist1[21]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[21]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[21]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[21]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [21] ? true : false,
      inputType: dateList.includes(autoselectlist1[21]?.text) ? "date" : numberlist.includes(autoselectlist1[21]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[21]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[22]?.dataField,
      text: autoselectlist1[22]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[22]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[22]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[22]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [22] ? true : false,
      inputType: dateList.includes(autoselectlist1[22]?.text) ? "date" : numberlist.includes(autoselectlist1[22]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[22]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[23]?.dataField,
      text: autoselectlist1[23]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[23]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[23]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[23]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [23] ? true : false,
      inputType: dateList.includes(autoselectlist1[23]?.text) ? "date" : numberlist.includes(autoselectlist1[23]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[23]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[24]?.dataField,
      text: autoselectlist1[24]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[24]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[24]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[24]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [24] ? true : false,
      inputType: dateList.includes(autoselectlist1[24]?.text) ? "date" : numberlist.includes(autoselectlist1[24]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[24]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[25]?.dataField,
      text: autoselectlist1[25]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[25]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[25]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[25]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [25] ? true : false,
      inputType: dateList.includes(autoselectlist1[25]?.text) ? "date" : numberlist.includes(autoselectlist1[25]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[25]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[26]?.dataField,
      text: autoselectlist1[26]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[26]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[26]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[26]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [26] ? true : false,
      inputType: dateList.includes(autoselectlist1[26]?.text) ? "date" : numberlist.includes(autoselectlist1[26]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[26]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
    },


  ];
  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },
    {
      dataField: 'coveredEntityName',
      text: 'Covered Entity',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.coveredEntityName),
    },
    {
      dataField: 'pharmacyName',
      text: 'Pharmacy Name',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: "npi",
      text: "Pharmacy NPI",
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: "poid",
      text: "PO Number",
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: "sourcePO",
      text: "Source PO Number",
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'podate',
      text: 'PO Date',
      sort: false,
      width: 144,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.podate)
    },

    {
      dataField: "poItemId",
      text: "PO Item #",
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: "drugId",
      text: "NDC",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: "drugDescription",
      text: "Drug Name",
      sort: false,
      width: 288,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "drugManufacturerName",
      text: "Mfg. Name",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "packageSize",
      text: "Package Size ",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "poItemStatus",
      text: "Item Status ",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "statusTypeCode",
      text: "StatusTypeCode",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "statusCodeDescription",
      text: "Status Code Description",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "packageOrdered",
      text: "Qty Ord",
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "packageAcknowledged",
      text: "Qty Ack",
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "packageInvoiced",
      text: "Qty Billed ",
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "itemAcknowledgedDate",
      text: "Ack Date",
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: "itemInvoicedDate",
      text: "Billed Date",
      sort: false,
      width: 144,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: "orderedPackagePrice",
      text: "Ordered Pkg. Price",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "orderedTotalPrice",
      text: "Total Ordered Price ",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "acknowledgedPackagePrice",
      text: "Ack. Package Price",
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "acknowledgedTotalPrice",
      text: "Total Ack.Price",
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "invoicedPackagePrice",
      text: "Billed Package Price",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "invoicedTotalPrice",
      text: "Total Billed Price",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "itemInvoiceNumber",
      text: "Invoice #",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
  ];
// console.log(autoselectlist1,"gopi1111")
  
  return (
    <div>
    <h5 className="f-16 text-primary font-weight-700">
      {/* Purchase Order Details Report Count ({totalSize}) */}
     {filters?.statusTypeId == 2 ? 'Purchase Order Details Non-Replenished Claims Report Count' : filters?.statusTypeId == 1 ? 'Purchase Order Details Replenished Claims Report Count' : 'Purchase Order Details Report Count' } ({totalSize})

    </h5>
    <hr />
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id='ReportPODetails-table'
        fixedColumn
        data={tableData}
        loading={loading}
        columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
        onPageSizeChange={onPageSizeChange}
        pageSize={filters.pageSize}
        AllExport={AllExport}
        slelectedExport={slelectedExportPOcoloumms}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={filters.currentPage}
        totalRecords={totalSize}
        handleSort={onHandleSort}
        filters={filters}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        onSelectColoums={handleselectColoums}
        autoselectlist1={autoselectlist1}
        hasColselect={true}
        disableSelectedColumn={disableSelectedColumn}
        toggleSider={toggleSider}
        enabletogglesider={true}
        collapseSider={collapseSider}
      />
      <Modal
        isOpen={coloumselect}
        toggle={handleselectColoums}
        size='lg'
        className='lg'
      >
        <ModalHeader toggle={handleselectColoums}>
          Column Selector
        </ModalHeader>
        <ModalBody>
          <DragDrop cancalcolselect={handleselectColoums} refetch={handleselectColoums} reloadautocolum={handlAutocoloms} modulename={modulename} />
          {/* <DragDrop cancalcolselect={handleselectColoums} refetch={handleFilterCancel} reloadautocolum={handlAutocoloms} modulename={modulename} /> */}
        </ModalBody>
      </Modal>
    </div>
    </div>
  )
}

export default ReportPODetailsTable;
